import clsx from 'clsx';
import Enllac from 'components/3catinfo/Enllac';
import Icona from 'components/3catinfo/ui/Icona';
import { useUser } from 'hooks/useUser';
import __filter from 'lodash/filter';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import styles from './menu.module.scss';

export default function MenuLogin(props) {
    const { requiredServices } = props;
    const { isAuthenticated, inicial, name, signUp, signOut, editProfileCP, changePassCP, changeEmail, deleteMyAccount } =
        useUser();
    const router = useRouter();
    const [openUsuari, setOpenUsuari] = useState(false);
    const [openMenuGestio, setOpenMenuGestio] = useState(false);
    const [isClosing, setIsClosing] = useState(false);
    const refUsuari = useRef(null);
    const refUsuariBtn = useRef(null);
    const refTancaButton = useRef(null); // Referència al botó 'tanca'
    const refGestionaButton = useRef(null); // Referència al botó 'gestiona'

    const stylesUsuari = clsx({
        [styles.menuUsuari]: true,
        [styles.open]: openUsuari,
        [styles.closing]: isClosing
    });

    const stylesBeforeUsuari = clsx({
        [styles.beforeMenuUsuari]: true,
        [styles.open]: openUsuari
    });

    const stylesMenuGestio = clsx({
        [styles.menuUsuariGestio]: true,
        [styles.open]: openMenuGestio
    });

    const loginAvailable = __filter(requiredServices?.servicesAvailability, function (servei) {
        return servei.login;
    });

    const obrirMenuGestiona = () => {
        setOpenMenuGestio(true);
        setTimeout(() => {
            if (refGestionaButton.current) {
                refGestionaButton.current.focus();
            }
        });
    };
    const tancarMenuGestiona = () => {
        setOpenMenuGestio(false);
        if (refTancaButton.current) {
            refTancaButton.current.focus();
        }
    };

    const handleOpenUsuari = () => {
        document.body.style.overflow = 'hidden';
        setOpenUsuari(!openUsuari);
        setTimeout(() => {
            if (refTancaButton.current) {
                refTancaButton.current.focus();
            }
            setIsClosing(false);
        });

        const elements = document.querySelectorAll(`.${styles.menuUsuari} [tabindex='-1']`);
        elements.forEach((element) => {
            element.setAttribute('tabindex', '0');
        });

        const elementsId = [
            '#menu-seo',
            '#mainMenu',
            '#barra-mobile',
            '#navLogo',
            '#navMarques',
            '#navCorpo',
            '#navBotiga',
            '#navCerca',
            'main',
            'footer'
        ];
        elementsId.forEach((id) => {
            const element = document.querySelector(id);
            if (element) {
                element.setAttribute('inert', true);
            }
        });
    };

    const handleCloseUsuari = () => {
        document.body.style.overflow = 'auto';
        setIsClosing(true);

        setTimeout(() => {
            setOpenUsuari(false);
            if (refUsuariBtn.current) {
                refUsuariBtn.current.focus();
            }
        });

        const elements = document.querySelectorAll(`.${styles.menuUsuari} [tabindex='0']`);
        elements.forEach((element) => {
            element.setAttribute('tabindex', '-1');
        });

        const elementsId = [
            '#menu-seo',
            '#mainMenu',
            '#barra-mobile',
            '#navLogo',
            '#navMarques',
            '#navCorpo',
            '#navBotiga',
            '#navCerca',
            'main',
            'footer'
        ];
        elementsId.forEach((id) => {
            const element = document.querySelector(id);
            if (element) {
                element.removeAttribute('inert');
            }
        });
    };

    // Si l'usuari navega amb el menú d'usuari obert (p. ex. clicant 'La meva llista'),
    // el component no es desmunta però els canvis aplicats a document.body i als
    // atributs 'inert' queden penjats i bloquejen el scroll a la pàgina següent.
    // Restaurem l'estat al detectar el canvi de ruta.
    useEffect(() => {
        const handleRouteChange = () => {
            if (openUsuari) {
                handleCloseUsuari();
            }
        };
        router.events.on('routeChangeStart', handleRouteChange);
        return () => {
            router.events.off('routeChangeStart', handleRouteChange);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openUsuari, router.events]);

    return loginAvailable.length > 0 ? (
        isAuthenticated ? (
            <div ref={refUsuari}>
                <button
                    className={`${styles.botoUsuari} botoOutline`}
                    aria-label="Obre el menú d'usuari"
                    onClick={handleOpenUsuari}
                    data-testid='menu-boto-usuari-autenticat'
                    ref={refUsuariBtn}
                >
                    <span>{inicial.toUpperCase()}</span>
                </button>

                <div className={stylesBeforeUsuari} onClick={handleCloseUsuari}></div>
                <div className={stylesUsuari}>
                    <div className={styles.menuUsuariWrapper}>
                        <div>
                            <button className={styles.tanca} onClick={handleCloseUsuari} ref={refTancaButton} tabIndex={-1}>
                                <Icona icona='tanca' isBlanc='true' mida='20' alt='Tanca el menú usuari' />
                            </button>
                            <div className={styles.headUsuari}>
                                <div className={styles.iconaUsuari}>
                                    <span>{inicial.toUpperCase()}</span>
                                </div>
                                <div className={styles.nomGestioUsuari}>
                                    <div className={styles.nom}>{name}</div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.scroll}>
                            <div className={styles.submenuUsuari}>
                                <Enllac
                                    className={styles.headerMeuUsuari}
                                    id='headerMeuUsuari'
                                    href='/3catinfo/meu3catinfo/'
                                    tabIndex={-1}
                                >
                                    El meu 3CatInfo
                                </Enllac>
                                <ul className={styles.meuMenu} aria-label='El meu 3CatInfo'>
                                    <li className={styles.meuMenuOpcio}>
                                        <Enllac className={styles.meuMenuOpcioLink} href='/3catinfo/meu3catinfo/' tabIndex={-1}>
                                            Els meus temes
                                        </Enllac>
                                    </li>
                                    <li className={styles.meuMenuOpcio}>
                                        <Enllac
                                            className={styles.meuMenuOpcioLink}
                                            href='/3catinfo/meu3catinfo/firmes/'
                                            tabIndex={-1}
                                        >
                                            Les meves firmes
                                        </Enllac>
                                    </li>
                                    <li className={styles.meuMenuOpcio}>
                                        <Enllac
                                            className={styles.meuMenuOpcioLink}
                                            href='/3catinfo/meu3catinfo/noticies/'
                                            tabIndex={-1}
                                        >
                                            Notícies guardades
                                        </Enllac>
                                    </li>
                                </ul>
                            </div>

                            <div>
                                <ul className={styles.mesOpcions}>
                                    <li className={styles.mesOpcions_item}>
                                        <Enllac className={styles.mesOpcions_link} href='/butlletins/' tabIndex={-1}>
                                            Butlletins
                                        </Enllac>
                                    </li>
                                    <li className={styles.mesOpcions_item}>
                                        <button className={styles.mesOpcions_btn} onClick={obrirMenuGestiona} tabIndex={-1}>
                                            <span>Gestiona el teu compte</span>
                                            <Icona
                                                icona='fletxa_simple_dreta'
                                                isBlanc='true'
                                                mida='32'
                                                alt='Tanca'
                                                ariaHidden='true'
                                            />
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            <div className={styles.tancarSessio}>
                                <button
                                    onClick={signOut}
                                    className={styles.contOpcioIcona}
                                    data-testid='menu-boto-tancar-sessio'
                                    tabIndex={-1}
                                >
                                    <span className={styles.ico_sortir}>
                                        <Icona icona='sortida' isBlanc='true' mida='24' alt='Tancar sessió' ariaHidden='true' />
                                    </span>
                                    <span className={styles.opcio_usuari}>Tanca sessió</span>
                                </button>
                            </div>
                        </div>
                        <div className={stylesMenuGestio}>
                            <div className={styles.gestioUsuari}>
                                <button
                                    className={styles.btnGestiona}
                                    onClick={tancarMenuGestiona}
                                    ref={refGestionaButton}
                                    tabIndex={-1}
                                >
                                    <Icona icona='fletxa_simple_esquerra' isBlanc='true' mida='24' alt='torna al menú usuari' />
                                </button>
                            </div>
                            <div className={styles.gestioTitol}>Gestiona el teu compte</div>
                            <div className={styles.scroll}>
                                <ul>
                                    <li className={styles.gestioOpcio}>
                                        <button onClick={editProfileCP}>
                                            <span className={styles.opcio_usuari}>Edita el teu perfil</span>
                                        </button>
                                    </li>
                                    <li className={styles.gestioOpcio}>
                                        <button onClick={changePassCP}>
                                            <span className={styles.opcio_usuari}>Canvia la contrasenya</span>
                                        </button>
                                    </li>
                                    <li className={styles.gestioOpcio}>
                                        <button onClick={changeEmail}>
                                            <span className={styles.opcio_usuari}>Canvia l&apos;adreça electrònica</span>
                                        </button>
                                    </li>
                                    <li className={styles.gestioOpcio}>
                                        <Enllac
                                            href='https://www.3cat.cat/configuracio-comunicacions/'
                                            className={styles.gestioOpcio_link}
                                        >
                                            <span className={styles.opcio_usuari}>Configura les comunicacions</span>
                                        </Enllac>
                                    </li>
                                    <li className={styles.gestioOpcio}>
                                        <button onClick={deleteMyAccount} className={styles.gestioOpcioBaixa}>
                                            <Icona icona='aspa_contorn' isBlanc='true' mida='24' alt='baixa' ariaHidden='true' />
                                            <span className={styles.opcio_usuari}>Dona&apos;t de baixa</span>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <button className={styles.botoLogin} onClick={() => signUp()} data-testid='menu-boto-login'>
                <Icona icona='usuari' className={styles.ico_usuari} alt='Fes login' inline={true} isBlanc={true} />
            </button>
        )
    ) : (
        <></>
    );
}
